import _property from 'lodash/property';
export var getFilterId = _property('id');
export var getFilterName = _property('name');
export var getFilterType = _property('type');
export var getFilterAdditional = _property('additional');